import { render, staticRenderFns } from "./SPMenu.vue?vue&type=template&id=735b6400"
import script from "./SPMenu.vue?vue&type=script&lang=js"
export * from "./SPMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports